export default "__VITE_ASSET__BAQRAyy$__"